{
  "common" : {
    "show" : "Anzeigen",
    "about" : "Über",
    "newPost" : "Neuer Post",
    "active" : "Aktiv",
    "change" : "Ändern",
    "remove" : "Entfernen",
    "cancel" : "Stornieren",
    "publish" : "Veröffentlichen",
    "save" : "Speichern",
    "draft" : "Entwurf",
    "scheduled" : "Geplant",
    "published" : "Veröffentlicht",
    "actions" : "Aktionen",
    "archive" : "Archiv",
    "delete" : "Löschen",
    "edit" : "Bearbeiten",
    "edited" : "Bearbeitet",
    "settings" : "Einstellungen",
    "updatedOn" : "Aktualisiert am",
    "blogPost" : "Blog-Post",
    "category" : "Kategorie",
    "author" : "Verfasser",
    "status" : "Status",
    "errors" : "Fehler",
    "all" : "Alle",
    "archived" : " Archiviert",
    "back" : "Zurück",
    "restore" : "Diese Version wiederherstellen",
    "next" : "Nächste",
    "previous" : "Vorherige",
    "continue" : "Weiter",
    "paid" : "Bezahlt",
    "free" : "Frei",
    "uploadImagesVideos" : "Bilder/Videos hochladen",
    "upload" : "Upload",
    "add" : "Hinzufügen",
    "to" : "zu",
    "on" : "An",
    "from" : "von",
    "members" : "Mitglieder",
    "visibility" : "Sichtbarkeit",
    "private" : "Privat",
    "public" : "Öffentlich",
    "description" : "Beschreibung",
    "managedBy" : "Verwaltet durch",
    "noManagers" : "Keine Manager",
    "noDescription" : "Keine Beschreibung",
    "more" : "Mehr",
    "less" : "weniger",
    "and" : "und",
    "in" : "in",
    "createdBy" : "Erstellt von",
    "home" : "Startseite",
    "selected" : "Ausgewählt",
    "groupMembers" : "Gruppenmitglieder",
    "everyone" : "Alle",
    "manager" : "Manager",
    "leave" : "Verlassen",
    "membersList" : "Mitgliederliste",
    "findChannelManagers" : "Channel-Manager finden",
    "searchGroupMembers" : "Gruppenmitglieder suchen",
    "searchMembers" : "Mitglieder suchen",
    "searchMember" : "Mitglied suchen",
    "enterDescription" : "Beschreibung eingeben",
    "apply" : "Anwenden",
    "selectRole" : "Rolle auswählen",
    "people" : "Menschen",
    "viewProfile" : "Profil ansehen",
    "leaderboard" : "Bestenliste",
    "events" : "Veranstaltungen",
    "logOut" : "Abmelden",
    "share" : "teilen",
    "copyLink" : "Link kopieren",
    "reply" : "Antwort",
    "download" : "Herunterladen",
    "noPreviewAvailable" : "Keine Vorschau verfügbar",
    "userNotFound" : "Benutzer nicht gefunden",
    "unableToPreviewPdf" : "Aktuell ist keine Vorschau der PDF-Datei möglich. Bitte laden Sie sie herunter, um sie anzusehen.",
    "failedToDownloadPdf" : "Fehler beim Herunterladen der PDF-Datei",
    "notifyAll" : "Alle im Channel benachrichtigen",
    "communities" : "Communitys",
    "courses" : "Kurse",
    "affiliates" : "Affiliates",
    "chats" : "Chat",
    "switchToDarkMode" : "In den dunklen Modus wechseln",
    "switchToLightMode" : "In den hellen Modus wechseln",
    "editProfile" : "Profil bearbeiten",
    "account" : "Konto",
    "logout" : "Abmelden",
    "noResults" : "Keine Ergebnisse",
    "confirmPayment" : "Zahlung bestätigen",
    "done" : "Erledigt",
    "manage" : "VERWALTEN",
    "copied" : "Kopiert",
    "submit" : "Absenden",
    "request" : "Anfrage",
    "approve" : "Genehmigen",
    "decline" : "Ablehnen",
    "comingSoon" : "Demnächst verfügbar",
    "detailsUpdatedSuccessfully" : "Details erfolgreich aktualisiert",
    "oopsUnableToSaveDetails" : "Hoppla! Die Details konnten nicht gespeichert werden.",
    "verificationFailedPleaseTryAgain" : "Verifizierung fehlgeschlagen! Bitte versuchen Sie es erneut.",
    "loading" : "Laden",
    "title" : "Titel",
    "addLink" : "Link hinzufügen",
    "writeHere" : "Schreibe hier",
    "copy" : "Kopieren",
    "register" : "registrieren",
    "search" : "Suchen",
    "confirm" : "Bestätigen",
    "success" : "Erfolg",
    "toReview" : "Zur Bewertung",
    "invite" : "Einladen",
    "contributions" : "Beitrage",
    "communitiesSettings" : "Communities Einstellungen",
    "create" : "Erstellen",
    "name" : "Name",
    "linkCopied" : "Link Kopiert!",
    "move" : "Verschieben",
    "irreversible" : "nicht rückgängig machen",
    "close" : "Schließen",
    "greeting" : "Willkommen, {name}!",
    "managePayments" : "Zahlungen Verwalten",
    "manageYourAccount" : "Verwalten Ihr Konto",
    "accountSettings" : "Konto Einstellungen",
    "proceed" : "Fortfahren",
    "uploading" : "Hochladen",
    "retry" : "Wiederholen"
  },
  "imageUpload" : {
    "cropYourAvatar" : "Schneiden Sie Ihren Avatar zu",
    "dragToReposition" : "Zur Neupositionierung ziehen"
  },
  "mediaUpload" : {
    "uploadVideo" : "Video hochladen",
    "addVideoUsingLink" : "Video per Link hinzufügen"
  },
  "mandatedInfoModal" : {
    "completeYourProfile" : "Ihr Profil vervollständigen",
    "profileIntentMessage1" : "Communitys ohne Gesichter und Namen fühlen sich seltsam an.",
    "profileIntentMessage2" : "Profile schaffen Vertrauen und knüpfen Verbindungen zu anderen",
    "complete" : "VOLLSTÄNDIG",
    "recommendedAspectRatio" : "Upload einen {types} hoch. Empfohlenes Erscheinungsbild 1:1",
    "addBio" : "Fügen Sie eine Biografie hinzu … (Optional)"
  },
  "validations" : {
    "nameRequired" : "Name ist erforderlich!",
    "invalidDescription" : "Ungültige Beschreibung!"
  },
  "payment" : {
    "recurringWithTrial" : "Nach Ablauf der Testphase werden Ihnen {currencySymbol}{price} pro {interval} in Rechnung gestellt, mit der Möglichkeit, jederzeit zu kündigen.",
    "recurring" : "{currencySymbol}{price} je {interval} mit der Option, jederzeit zu kündigen.",
    "oneTime" : "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText" : "einmaliger Preis für das Abonnement.",
    "totalAmount" : "Gesamtbetrag",
    "trialDays" : "{days}-tägige Testversion",
    "securePayments" : "100 % sichere Zahlungen",
    "allowToChargeCard" : "Durch die Angabe Ihrer Karteninformationen erlauben Sie {locationName}, Ihre Karte für zukünftige Zahlungen gemäß deren Bedingungen zu belasten.",
    "paymentSuccessful" : "Zahlung erfolgreich!"
  },
  "channel" : {
    "notifications" : {
      "managersEdited" : "Manager erfolgreich bearbeitet!",
      "managersAdded" : "Manager erfolgreich hinzugefügt!",
      "managersAddedToChannel" : "Manager hinzugefügt zu",
      "memberPostingEnabled" : {
        "title" : "Erfolgreich aktualisierte Mitglieder bei der Buchung",
        "content" : "Der Beitrag von Benutzern wurde aktiviert"
      },
      "memberPostingDisabled" : {
        "title" : "Erfolgreich aktualisierte Mitglieder bei der Buchung",
        "content" : "Der Mitglieder-Beitrag wurde deaktiviert"
      },
      "created" : {
        "title" : "Neuer Channel wurde erstellt",
        "content" : ""
      },
      "updated" : {
        "title" : "Aktualisierte Kanaleinstellungen",
        "content" : ""
      },
      "deleted" : {
        "title" : "Kanal wurde erfolgreich gelöscht",
        "content" : ""
      },
      "error" : {
        "createFailed" : {
          "title" : "Channel konnte nicht erstellt werden",
          "content" : "Bitte versuchen Sie es später erneut."
        },
        "updateFailed" : {
          "title" : "Channel konnte nicht aktualisiert werden",
          "content" : "Bitte versuchen Sie es später erneut."
        },
        "managersEditedFailed" : {
          "title" : "Aktualisieren von Managern nicht erfolgreich!",
          "content" : ""
        },
        "addFailed" : {
          "title" : "Hinzufügen von Managern nicht erfolgreich!",
          "content" : ""
        }
      }
    },
    "createChannel" : "Kanal erstellen",
    "updateChannel" : "Update-Kalender",
    "addMembers" : "Mitglieder hinzufügen",
    "addManagers" : "Manager hinzufügen",
    "typeToAddMoreMembers" : "Tippen, um weitere Mitglieder hinzuzufügen",
    "examplePlaceholder" : "z. B. John oder Jane",
    "makeChannelManager" : "Channel Manager erstellen",
    "removeFromChannelManager" : "Aus dem Channel Manager entfernen",
    "manager" : "Manager",
    "channelManager" : "Channel Manager",
    "noMembersFound" : "Keine Mitglieder gefunden.",
    "noManagersFound" : "Keine Manager gefunden.",
    "removeChannelMember" : "Kanalmitglied entfernen",
    "removeConfirmationMessage" : "Möchten Sie folgende Person(en) wirklich entfernen?",
    "makeManagerConfirmationMessage" : "Möchten Sie",
    "makeManagerConfirmationMessage2" : "wirklich zum Channel Manager in folgendem Channel machen?",
    "channelName" : "Kanalname",
    "channelIcon" : "Channel-Symbol",
    "addChannel" : "Channel hinzufügen",
    "editChannel" : "Kanal Bearbeiten",
    "announcementChannel" : "Anmerkung des Kanal",
    "noChannelsAvailable" : "Keine Kanäle verfügbar",
    "makeChannelPrivate" : "Channel Privat machen",
    "makeChannelPrivateMessage" : "Beschränken Sie den Zugriff der Mitglieder auf alle Diskussionen und Interaktionen im Channel.",
    "readOnlyChannel" : "Lesen Kanal",
    "readOnlyChannelMessage" : "Mitglieder können WICHTIG Informationen und Updates anzeigen, aber nur Administratoren/Eigentümer des Kanals können hier Story .",
    "createPrivateChannel" : "Erstelle diesen Kanal Privat",
    "createPrivateChannelMessage" : "Nur geladene Mitglieder . Nicht-mitglieder werden diesen Platz nicht sehen",
    "allowMembersToPost" : "Mitglieder to Story aktivieren",
    "allowMembersToPostMessage" : "Durch Aktivieren dieser Option „Aktivieren Sie Mitglieder“, um Beiträge und Feedback zu erstellen",
    "enableMemberPostingConfirmation" : {
      "mainMessage" : "Durch das Aktivieren von Mitglieder-Beiträgen werden alle Mitglieder aktiviert, um Posts innerhalb des Kanals zu erstellen und zu teilen.",
      "mainMessage2" : "Stelle sicher, dass alle Mitglieder über die Neubuchungs-Berechtigung Bescheid wissen.",
      "pointer1" : "Diese Aktion kann an einem beliebigen Datum rückgängig gemacht werden.",
      "pointer2" : "Jeder Beitrag Erstellt von Mitglieder ist für alle in Kanal sichtbar."
    },
    "restrictMembersFromPosting" : "Beschränkung der Buchung von Benutzern von",
    "restrictMembersFromPostingMessage" : "Deaktivieren dieser Option verhindert, dass Mitglieder von Erstellt Oder Einträge und Feedback innerhalb des Kanals bearbeiten.",
    "disableMemberPostingConfirmation" : {
      "mainMessage" : "Deaktivieren von Mitglieder-Beiträgen wird jeder Mitglieder von Erstellt und das Teilen von Posts innerhalb des Kanals eingeschränkt.",
      "mainMessage2" : "Stelle sicher, dass alle Mitglieder die Einschränkungen für Neu-Posts beachten.",
      "pointer1" : "Diese Aktion kann an einem beliebigen Datum rückgängig gemacht werden.",
      "pointer2" : "Jeder Beitrag Erstellt von Mitglieder Vorher dieser Änderung bleibt für alle in Kanal sichtbar."
    },
    "deleteChannel" : "Kanal löschen",
    "deleteChannelMessage" : "Durch das Löschen des Kanals gehen alle zugehörigen Daten dauerhaft verloren.",
    "deleteChannelMessageWithCourse" : "Löschen des Kanals gehen alle Daten der Mitglieder dauerhaft verloren, und alle mit diesem Kanal verknüpften Kurse werden Öffentlich, es sei denn, Sie löschen sie zuerst.",
    "editChannelName" : "Namen des Channels bearbeiten",
    "editChannelDescription" : "Kanalbeschreibung bearbeiten",
    "channelNamePlaceholder" : "z. B. Marketingberichte",
    "editManagers" : "Manager bearbeiten",
    "channelManagers" : "Channel Manager",
    "leaveChannel" : "Kanal verlassen",
    "leaveChannelConfirmation" : "Möchtest du diesen Kanal wirklich löschen?",
    "changeToPrivateChannel" : "Channel Privat machen",
    "changeToPrivateChannelMessage" : "Wenn Sie den Channel privat machen, wird die Nutzung des Channels für Interaktionen und Diskussionen auf seine Mitglieder beschränkt.",
    "changeToPrivateChannelConfirmation" : {
      "mainMessage" : "Wenn du diesen Kanal zu Privat wechselst, werden MAX. ZEITFENSTER Zugriff nur auf Ausgewählte Mitglieder und Manager.",
      "mainMessage2" : "Erinnere dich, alle gewünschte Mitglieder in deinen Privaten Kanal einbeziehen zu können.",
      "pointer1" : "Diese Aktion ist",
      "pointer2" : "Neue Mitglieder, die dem Kanal hinzugefügt wurden, haben Zugriff auf jeder VERÄNDERNDE Diskussionen und Interaktionen innerhalb des Kanals."
    },
    "peopleWhoCanManage" : "Personen mit Verwaltungsrechten",
    "addChannelHelperText" : "Mehr anzeigen Community: Kanäle für verschiedene Diskussionen, Duet und Verbindung hinzufügen."
  },
  "chat" : {
    "unblockUser" : "Benutzer entsperren",
    "blockUser" : "Benutzer blockieren",
    "blockMessage1" : "Sie können diesem Benutzer keine Nachrichten mehr senden.",
    "blockMessage2" : "Dieses Konto wird in der Gruppe nicht gesperrt. Möglicherweise können Sie seine Beiträge, Kommentare und Reaktionen weiterhin sehen.",
    "deleteChat" : "Chat löschen",
    "deleteChatMessage" : "Sind Sie sicher, dass Sie dieses Gespräch löschen möchten?",
    "block" : "Blockieren",
    "conversation" : "Gespräch",
    "messageNotSent" : "Diese Nachricht wurde nicht gesendet",
    "sending" : "Wird gesendet",
    "youAndUserKnowEachOther" : "Sie und {name} kennen sich",
    "startConversationWithHi" : "Beginnen Sie ein Gespräch, indem Sie „Hallo“ schreiben.",
    "accountSettings" : "Kontoeinstellungen",
    "blockedUserMessage" : "Sie haben { name } blockiert. Sie können keine Nachrichten senden oder empfangen. Heben Sie die Blockierung auf, um ein Gespräch zu beginnen. Um Ihre Liste der blockierten Benutzer zu überprüfen, besuchen Sie Ihr/Ihre/Ihren",
    "blockRecipientMessage" : "{ name } hat Sie blockiert. Sie können keine Nachrichten senden oder empfangen.",
    "nothingFound" : "Nichts gefunden!",
    "pleaseCheckUsername" : "Bitte überprüfe den Benutzernamen und versuche es erneut.",
    "startChatting" : "Beginnen Sie zu chatten",
    "noChatYet" : "Sieht so aus, als hätten Sie noch mit niemandem gechattet.",
    "noChatYetMessage" : "Suchen Sie einen Kontakt und machen Sie den ersten Schritt!",
    "noConversationsFound" : "Keine Konversationen gefunden",
    "searchMembersAndStartChatting" : "Suchen Sie nach Mitgliedern und chatten Sie los",
    "cannotMessageDeletedUser" : "Sie können keine Nachrichten an einen Gelöschten Benutzer Upload",
    "message" : "Nachricht",
    "media" : "Medien",
    "files" : "Dateien"
  },
  "comments" : {
    "reportComment" : "Kommentar melden",
    "reportCommentMessage" : "Möchten Sie diesen Kommentar wirklich melden?",
    "deleteComment" : "Kommentar löschen",
    "editComment" : "Kommentar bearbeiten",
    "loadMoreReplies" : "Mehr Antworten laden",
    "deleteCommentMessage" : "Möchten Sie diesen Kommentar wirklich löschen?",
    "writeComment" : "Einen Kommentar schreiben",
    "comment" : "KOMMENTAR",
    "cancel" : "ABBRECHEN",
    "save" : "SPEICHERN",
    "replyingTo" : "Antwort auf",
    "newComment" : "Neuer Kommentar",
    "latest" : "Neuestes",
    "onlyAdminsCanComment" : "Nur Community -administratoren können in diesem Kanal Kommentare abgeben."
  },
  "embeds" : {
    "uploadImage" : "Bild hochladen",
    "addYoutubeVimeoLoomLink" : "Einen YouTube-, Vimeo- oder Loom-Link hinzufügen",
    "uploadAttachment" : "Laden Sie PDF-, CSV- oder XLSX-Dateien hoch",
    "addAttachment" : "Anhang hinzufügen",
    "allowedTypes" : "SVG, PNG, JPG oder GIF (max. 800x400px)",
    "placeholder" : "Einen YouTube-, Vimeo- oder Loom-Link hinzufügen",
    "uploadVideo" : "Video hochladen/verknüpfen",
    "uploadVideoPlaceholder" : "Einen YouTube-, Vimeo- oder Loom-Link hinzufügen",
    "uploadVideoAllowedTypes" : "Laden Sie eine MP4-Videodatei hoch",
    "addEmoji" : "Emoji hinzufügen",
    "emojiSuggestion" : "Öffnet die Emoji-Auswahl",
    "addGif" : "GIF hinzufügen",
    "gifSuggestion" : "Öffnet die GIF-Auswahl",
    "addImage" : "Foto hinzufügen",
    "imageSuggestion" : "Öffnet Ihre Galerie",
    "addVideo" : "Video hinzufügen",
    "videoSuggestion" : "Öffnet Ihre Galerie",
    "selectFile" : "Datei auswählen",
    "attachmentSuggestion" : "Öffnet den Dateimanager",
    "takePhoto" : "Foto aufnehmen",
    "uploadPhotoVideo" : "Foto/Video hochladen",
    "limitExceeded" : "Limit überschritten",
    "limitExceededMessage" : "Sie können nicht mehr als 4 Dateien anhängen",
    "errorWhileUploadingFile" : "Fehler beim Hochladen der Datei! Bitte versuchen Sie es erneut.",
    "clickToUpload" : "Zum Hochladen klicken",
    "orDragAndDrop" : "oder ziehen und ablegen",
    "validUrl" : "Eine gültige URL ist erforderlich",
    "enterSomeText" : "Geben Sie einen Text ein",
    "addLink" : "Link hinzufügen",
    "text" : "Text",
    "addVideoLink" : "Oder, Einbeziehen eines YouTube Vimeo Wistia .",
    "uploadVideoAndImages" : "Upload Video und Bilder hoch",
    "recommendedAspectRatio" : "Empfohlenes Erscheinungsbild Auftreten {ratio}"
  },
  "tabSwitcher" : {
    "discussion" : "Diskussion",
    "learning" : "Lernen",
    "members" : "Mitglieder",
    "leaderboard" : "Bestenliste",
    "channels" : "Kanäle",
    "groups" : "Gruppen",
    "more" : "Mehr",
    "home" : "Startseite"
  },
  "groupInfo" : {
    "pinGroup" : "Link Gruppe",
    "unpinGroup" : "Gruppe lösen",
    "maxPinnedGroupsLimit" : "Es können nur bis zu 4 Gruppen angefixt werden",
    "publicGroup" : "Öffentliche Gruppe",
    "privateGroup" : "Private Gruppe",
    "members" : "Mitglieder",
    "posts" : "Beiträge",
    "admin" : "Admin",
    "settings" : "EINSTELLUNGEN",
    "inviteMembers" : "MITGLIEDER EINLADEN",
    "answerQuestions" : "Fragen beantworten",
    "toJoin" : "um {name} beizutreten",
    "changeRole" : "Rolle ändern",
    "removeFromGroup" : "Aus Gruppe entfernen",
    "contributor" : "Mitwirkender",
    "membershipAnswers" : "Mitgliedschaftsantworten",
    "unbanMember" : "Mitglied entsperren",
    "banFromGroup" : "Zugang zur Gruppe sperren",
    "requestedOn" : "Angefordert am",
    "invitedOn" : "Eingeladen am",
    "joinedOn" : "Beigetreten",
    "noMembersFound" : "Keine Mitglieder gefunden.",
    "youAreAllCaughtUp" : "Sie sind jeder eingeholt – keine Mitglieder hier Rechts jetzt!",
    "banUserConfirmation" : "Möchten Sie diesen Benutzer wirklich aus der Gruppe ausschließen?",
    "deleteContentCheckbox" : "Löschen jeden Inhalt von diesem Benutzer erstellt",
    "active" : "Aktiv",
    "admins" : "Admins",
    "contributors" : "Mitwirkende",
    "requested" : "Angefordert",
    "banned" : "Gesperrt",
    "invited" : "Eingeladen",
    "answeredQuestions" : "Beantwortete Fragen",
    "answeredQuestionsMessage" : "habe die folgende Frage beantwortet, um beizutreten",
    "darkMode" : "Dunkelmodus",
    "darkModeMessage" : "Ändern Sie das Erscheinungsbild der Community, um weniger geblendet zu werden und Ihren Augen eine Pause zu gönnen.",
    "accessGranted" : "Zugriff gewährt: Beginnen Sie Ihr Lernabenteuer.",
    "paymentReceived" : "Die Zahlung wurde empfangen und Ihre Anfrage zum Beitritt zur Gruppe wird geprüft.",
    "stepIntoAction" : "Werden Sie aktiv! Lassen Sie uns zusammenarbeiten und Spaß haben.",
    "viewMembersAndMemberDetails" : "Mitglieder und Mitgliederdetails anzeigen",
    "reviewContentReportsAndMore" : "Inhaltsmeldungen und mehr überprüfen",
    "toReview" : "Zur Überprüfung",
    "switchToOtherGroups" : "Wechsle zu Andere Gruppe",
    "placeholders" : {
      "yourAnswer" : "Ihre Antwort"
    },
    "notifications" : {
      "userBanned" : "Der Zugang des Benutzers zur Gruppe wurde erfolgreich gesperrt",
      "somethingWentWrong" : "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut."
    },
    "membershipSettings" : "Abonnement-Einstellungen",
    "paymentFailed" : "Zahlung fehlgeschlagen!",
    "paymentFailedMessage" : "Die Zahlung ist fehlgeschlagen – Ihre Anfrage, der Gruppe beizutreten, wurde abgelehnt.",
    "gamification" : {
      "addRewards" : "Belohnungen hinzufügen",
      "title" : "Titel",
      "description" : "Beschreibung hinzufügen",
      "textbox" : "Textfeld",
      "singleSelect" : "Einzelauswahl",
      "multipleSelect" : "Mehrfachauswahl",
      "question" : "Frage",
      "validations" : {
        "titleRequired" : "Bitte geben Sie einen Titel an",
        "descriptionRequired" : "Bitte geben Sie eine Beschreibung an",
        "somethingWentWrong" : "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
        "updatedRewards" : "Aktualisierte Belohnungen"
      }
    },
    "customCode" : {
      "advanced" : "Erweitert",
      "testPreview" : "Testvorschau",
      "enableConfirmationMessage" : "Aktivieren Sie dies erst, wenn Sie die Testvorschau überprüft haben",
      "testPreviewMessage" : "Dies öffnet eine neue Registerkarte mit der Testvorschau Ihrer Community. Damit können Sie überprüfen, ob Ihr benutzerdefinierter Code wie erwartet funktioniert.",
      "liveMode" : "Live Modus",
      "customJS" : "Benutzerdefiniert JS",
      "customCSS" : "Benutzerdefiniert CSS",
      "trackingCode" : "Tracking-Code",
      "headerCode" : "Überschrift Code",
      "footerCode" : "Fußzeile Code"
    },
    "branding" : {
      "brandYourGroup" : "Sie können Ihrer Gruppe hier nach Ihren Wünschen ein Branding hinzufügen",
      "updateBranding" : "Branding aktualisieren",
      "clickToUploadFavicon" : "Zum Hochladen des Favicon klicken",
      "dragAndDropFavicon" : "Drag and drop a {types} (Aspect Ratio 1:1)",
      "clickToUploadCover" : "Zum Hochladen des Covers klicken",
      "dragAndDropCover" : "Drag and drop a {types} (Aspect Ratio 16:9)",
      "clickToUploadLogo" : "Zum Hochladen des Gruppenlogos klicken",
      "dragAndDropLogo" : "Drag and drop a {types} (Aspect Ratio 1:1)",
      "aspectRatioMustBe1To1" : "Das Seitenverhältnis des Bildes muss 1:1 sein",
      "aspectRatioMustBe16To9" : "Das Seitenverhältnis des Bildes muss 16:9 sein",
      "favicon" : "Favicon",
      "coverImage" : "Coverbild",
      "logo" : "Logo",
      "invalidFileFormat" : "Oops! Invalid File Format/Type.",
      "pleaseUploadImageType" : "Supported file types: {types}"
    },
    "groupAppearance" : {
      "description" : "Sie können Ihr Gruppe Erscheinungsbild als je Ihre Wahl hier konfigurieren",
      "slug" : "Aktualisierung deine Gruppe Erscheinungsbild hier",
      "colorMode" : "Farbe",
      "previewTheLook" : "Vorschau, wie sich deine Gruppe in Leicht- und Schattenmodus sehen wird",
      "light" : "Leicht",
      "dark" : "Dunkel",
      "communityTheme" : "Community- Thema",
      "customTheme" : "Benutzerdefiniert Thema",
      "windowGradient" : "Fenster Farbverlauf",
      "applyGradientColorsToYourSidebarAndTopbar" : "Anwenden Farbverlaufsfarbe auf Ihre Seitenleiste und Topleiste",
      "labels" : {
        "sidebarBackground" : "Hintergrund der Seitenleiste",
        "primary" : "PRIMÄRE",
        "secondary" : "Sekundär",
        "tertiary" : "Terminär",
        "surface" : "Seite",
        "fontPrimary" : "PRIMÄRE Schriftart",
        "fontSecondary" : "Zweite Schriftart",
        "fill" : "füllen Farbe",
        "border" : "Abgrenzung",
        "error" : "Fehler",
        "background" : "Hintergrund"
      },
      "customThemes" : {
        "default" : "Standard",
        "zestyCitrus" : "Lustig in der Mitte",
        "royalVelvet" : "Konigs-Von aus",
        "sunnyDelight" : "Sonne und Sonne",
        "lushMeadow" : "Füge Wiege hinzu",
        "azureDreams" : "Azur-Träume",
        "bubblegumBliss" : "Bump-Gligkeit",
        "ivoryWhisper" : "White Whisper",
        "midnightDeep" : "Mitten in der Mitte"
      },
      "unsavedChanges" : "Ungespeicherte Dynamisch",
      "unsavedChangesMessage" : "Sie haben ungespeichertes Thema Dynamisch. Möchten Sie das Dynamisch wirklich rückgängig machen?"
    },
    "promotionalLinks" : {
      "promotionalLinks" : "Werbe-Links",
      "createPromotionalLinkDescription" : "Erstellen Sie Werbe-Links für Ihre Gruppe",
      "addPromotionalLink" : "Link hinzufügen",
      "deleteLink" : "Link löschen",
      "deleteLinkConfirmation" : "Möchten Sie diesen Link wirklich löschen?",
      "labels" : {
        "description" : "Beschreibung",
        "url" : "URL",
        "private" : "Privat",
        "privateLinksDescription" : "Private Links sind nur für Gruppenmitglieder sichtbar"
      },
      "placeholders" : {
        "enterLinkDescription" : "Linkbeschreibung eingeben",
        "enterLinkURL" : "Link-URL eingeben"
      },
      "addPromotionalLinkDescription" : "Erstellen Werbe-Links für Ihre Gruppe"
    },
    "membershipQuestions" : {
      "addQuestion" : "Frage hinzufügen",
      "editQuestion" : "Frage bearbeiten",
      "editLevelName" : "Namen der Ebene bearbeiten",
      "addOption" : "Option hinzufügen",
      "level" : "Ebene",
      "name" : "Name",
      "addMembersQuestionsDescription" : "Fügen Sie Mitgliederfragen hinzu, die sie beantworten sollen, wenn sie Zugang zu Ihrer Gruppe beantragen",
      "enableMembershipQuestions" : "Fragen zur Mitgliedschaft aktivieren",
      "membershipQuestions" : "Mitgliedschaftsfragen",
      "deleteQuestion" : "Frage löschen",
      "deleteQuestionConfirmation" : "Möchten Sie diese Frage wirklich löschen?",
      "labels" : {
        "textBox" : "Textfeld",
        "singleSelect" : "Einzelauswahl",
        "multipleSelect" : "Mehrfachauswahl",
        "enableMembershipQuestions" : "Fügen Sie mindestens eine Frage hinzu, um die Mitgliedschaft zu aktivieren"
      },
      "validations" : {
        "questionRequired" : "Bitte geben Sie eine Frage ein",
        "answerOptionsRequired" : "Es sind mindestens zwei Optionen erforderlich, und sie müssen einzigartig sein",
        "somethingWentWrong" : "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
        "updatedQuestions" : "Mitgliedschaftsfragen wurden aktualisiert",
        "levelNameRequired" : "Bitte geben Sie den Namen der Ebene ein",
        "updatedLevelName" : "Name der Ebene wurde aktualisiert"
      },
      "placeholders" : {
        "enterLevelName" : "Ebenenname",
        "selectOne" : "Eine Option auswählen",
        "keepItShort" : "Halten Sie es kurz …",
        "exampleOffer" : "z. B 10 % Deaktiviert Ein erster Kauf"
      },
      "privacyNotice" : "Ich gehe davon aus, dass meine Antworten archiviert und für Gruppenadministratoren sichtbar sind."
    },
    "gamificationAndRewards" : {
      "title" : "Levels und Belohnungen anpassen",
      "description" : "Passen Sie die Levelnamen an und fügen Sie Belohnungen hinzu, um die Mitglieder stärker einzubinden",
      "gamification" : "Gamifizierung",
      "rewards" : "Belohnungen",
      "addRewards" : "Belohnung hinzufügen"
    },
    "invitations" : {
      "invitationSentSuccessfully" : "Einladung erfolgreich gesendet",
      "invitationSentSuccessfullyDescription" : "Einladung gesendet an {email}",
      "shareGroupLink" : "Teilen Sie Ihren Gruppenlink",
      "inviteMember" : "Mitglied einladen",
      "inviteMemberDescription" : "Bauen Sie Ihre Community auf, indem Sie ein neues Mitglied einladen",
      "inviteViaEmail" : "Per E-Mail einladen",
      "invitedMembersWillBeAutoApproved" : "Eingeladene Mitglieder werden automatisch zur Gruppe zugelassen",
      "sendInvite" : "EINLADUNG SENDEN",
      "permissionDenied" : "Sie haben nicht die Autorisierung, um Mitglieder einzuladen. Bitte kontaktiere deinen Administrator.",
      "labels" : {
        "giveAdministrativePrivileges" : "Administratorrechte gewähren",
        "giveAdministrativePrivilegesDescription" : "Diesem Mitglied erlauben, alle administrativen Aktionen auszuführen",
        "name" : "Name",
        "email" : "E-Mail"
      },
      "placeholders" : {
        "enterName" : "Namen eingeben",
        "enterEmail" : "E-Mail-Adresse eingeben"
      }
    },
    "groupDetails" : {
      "updateGroupDetails" : "Gruppendetails aktualisieren",
      "updateGroupDetailsDescription" : "Aktualisieren Sie hier Ihre Gruppendetails",
      "slugNotAvailable" : "Gruppen-Slug nicht verfügbar",
      "description" : "Erläutern Sie die Art der Diskussionen, die innerhalb der Gruppe stattfinden werden",
      "publicDescription" : "Jeder kann die Beiträge der Gruppe und andere Mitglieder der Gruppe sehen",
      "privateDescription" : "Nur Mitglieder können die Beiträge der Gruppe und andere Mitglieder der Gruppe sehen",
      "accessibleFromSwitcher" : "Vom Switcher aus zugänglich",
      "accessibleFromSwitcherDescription" : "Ihre Sammlung ist für Nicht-Gruppenmitglieder im Switcher sichtbar",
      "allowMembersToInvite" : "Mitglieder aktivieren, um Neue Mitglieder einzuladen",
      "allowMembersToInviteDescription" : "Ausblenden der Einladungs-Schaltfläche für Mitglieder, wenn Deaktiviert eingeschaltet ist. Mitglieder können nur Andere Falls einladen, dies ist Aktiviert.",
      "slug" : "Gruppen-Slug",
      "discovery" : {
        "title" : "Entdeckung",
        "description" : "Lassen Sie sich von Millionen aktiver Benutzer entdecken. Sobald Sie mehr als 10 Mitglieder haben, wird die Gruppe auf der Discover-Seite angezeigt.",
        "discoverChannels" : "Kanäle Discover",
        "joinGroupToExploreAllChannels" : "beitreten der Gruppe, um jeder der Kanäle zu erkunden"
      },
      "placeholders" : {
        "description" : "Geben Sie eine kurze Beschreibung ein"
      },
      "validations" : {
        "nameRequired" : "Bitte geben Sie einen gültigen Gruppennamen ein!",
        "slugRequired" : "Bitte geben Sie einen gültigen Gruppen-Slug ein!",
        "specialCharacterNotSupported" : "Sonderzeichen nicht unterstützt",
        "descriptionRequired" : "Gruppenbeschreibung ist erforderlich!",
        "emailRequired" : "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
        "fullNameRequired" : "Bitte geben Sie einen gültigen Namen ein!"
      },
      "labels" : {
        "groupName" : "Gruppe"
      }
    },
    "subscriptions" : {
      "manageSubscriptions" : "Verwalten Sie Ihr Abonnement",
      "viewAndManageGroupSubscriptions" : "Ansicht und Verwalten Gruppe Abonnement",
      "paymentIntegrationMissingMessage" : "Bitte integrieren Sie Zahlungen in Standort, um Bezahlt Gruppe zu aktivieren",
      "price" : "Preis",
      "currency" : "Währung",
      "priceDisplay" : "{symbol}{price}{suffix}",
      "priceInterval" : "/{interval}",
      "oneTime" : " Ein Datum",
      "priceDeletedAlert" : "Das Bezahlung Produkt ist Von Synchronisierung, Klicken Sie hier, um es erneut zu synchronisieren",
      "intervals" : {
        "month" : "Monat",
        "year" : "Jahr",
        "week" : "Woche",
        "day" : "Tag"
      },
      "addNewPrice" : "Neuen Preis hinzufügen",
      "editPrice" : "Preis Bearbeiten",
      "addPrice" : "Preis Hinzufügen",
      "subscriptionType" : {
        "recurring" : "Wiederkehrend",
        "oneTime" : "Ein Datum"
      },
      "billingPeriod" : {
        "monthly" : "Monatlich",
        "annually" : "Jährlich",
        "weekly" : "Wöchentlich",
        "daily" : "Täglich"
      }
    },
    "menuOptions" : {
      "details" : "Details",
      "subscriptions" : "Abonnement",
      "branding" : "Branding",
      "themes" : "Thema",
      "membershipQuestions" : "Fragen zur Mitgliedschaft",
      "gamificationAndRewards" : "Gamifizierung und Besprechungen",
      "links" : "Links",
      "reportedContent" : "Gemeldeter Inhalt",
      "discovery" : "Entdecken",
      "import" : "Importieren"
    },
    "groupSettings" : {
      "groupSettings" : "Gruppe Einstellungen",
      "changeGroupType" : "Größer Gruppe eintippen",
      "changeGroupTypeDescriptionPrivateToPublic" : "Dynamisch zu einer Öffentlich Gruppe bedeutet, dass jeder Anhängig Anfragen automatisch angenommen wird und der Inhalt öffentlich sichtbar wird. Fortfahren?",
      "changeGroupTypeDescriptionPublicToPrivate" : "Dynamisch zu einer Privat Gruppe bedeutet, dass neue Mitglieder die Genehmigung benötigen und der Inhalt Versteckt bleibt, bis sie angenommen werden. Fortfahren?",
      "changeGroupTypeConfirmation" : "Möchten Sie die Gruppe wirklich eintippen?",
      "changeGroupTheme" : "Gruppe Thema Ändern",
      "changeGroupThemeDescription" : "Dies wird das Thema für jeden der Gruppe-mitglieder ändern. Möchten Sie die Gruppe Thema wirklich ändern?",
      "updatedGroupDetails" : "Aktualisierte Gruppe Details",
      "unableToSaveDetails" : "Oops! Details können nicht archiviert werden.",
      "groupNameIsRequired" : "Der Name ist erforderlich",
      "groupDescriptionIsRequired" : "Gruppe Beschreibung ist erforderlich",
      "groupSlugIsRequired" : "Gruppe Slug ist Erforderlich",
      "groupSlugAlreadyExists" : "Gruppe Slug existiert bereits. Bitte verwenden Sie einen anderen Slug , da dieser bereits vergeben ist",
      "pleaseTryAgainLater" : "Bitte Erneut versuchen Sie es später",
      "unsavedChangesMessage" : "Sie haben ungespeicherte Gruppe Slug Dynamisch, möchten Sie sie wirklich rückgängig machen?"
    },
    "import" : {
      "header" : "Importieren der Gruppe Mitglieder und deren Inhalt",
      "credentialDescription" : "Geben Sie Ihr Vorankündigungsfrist-Zertifikat ein, um Ihre Gruppe-mitglieder und deren Inhalt zu importieren",
      "csvUploadDescription" : "Auswählen .csv File zum Importieren von Kontakten Von Vorankündigungsfrist",
      "loginFailed" : "Sie haben ein ungültiges E-Mail- oder password eingegeben. Bitte Erneut versuchen.",
      "proceedWithImport" : "Mit dem Importieren Fortfahren ?",
      "iAgree" : "Ich stimmte zu",
      "importTerms" : "Via Klicken auf „ Ich stimmte zu“ bestätigen Sie und erkennen an, dass Sie uns als unabhängigen Vertrag mit der Erbringung von Diensten in Ihrem Namen („Dienste“) beauftragt haben. Die Dienste Einbeziehen die Transfer von bestimmten Daten, Details, Inhalten, geistigen Eigenschaften oder einem anderen Inhalt („Info“) von einem ausgestellten Plattformkonto auf ein empfangendes Plattformkonto. Sie erklären und Garantie, dass (i) Sie der rechtmäßige Eigentümer der Info in Ausgestellten Plattformkonto sind, (2) Sie die Berechtigungen haben, uns Zugriff auf das Ausgestellte Plattformkonto für die Absicht zu geben, die Dienste zu erbringen, und (Ii) Die Transfer der Info wird nicht die geistigen Eigenschaften eines Dritten verstoßen oder gegen Pläne Dritter verstoßen. Sie erklären sich damit einverstanden, uns von allen Ansprüchen Dritter freizustellen, zu verteidigen und schadlos zu halten, die sich aus Ihrem Verstoß gegen die oben genannten Vertreter und Garantien ergeben.",
      "pleaseDownloadCSV" : "Bitte laden Sie die .csv- File herunter",
      "step01" : "Schritt 01-",
      "step02" : "Schritt 02-",
      "uploadCSV" : "Upload Ihre .csv hoch",
      "step01Description" : "Füllen Sie in Oder aktualisiere alle verpassten Details für Gruppe-mitglieder wie Gmail, Vorname usw. Stelle sicher, dass die CSV inhochgeladen wird",
      "thisTemplate" : "Diese Vorlage",
      "importCSV" : "Importieren .csv",
      "reSyncData" : "Erneut synchronisieren Ihre Daten vorher Herunterladen.",
      "refreshUserList" : "Benutzerliste Aktualisieren",
      "reSyncDataDescription" : "Falls neue Benutzer in wurden, empfehlen wir Ihnen, Ihre Liste zu aktualisieren und die CSV herunterladen.",
      "pleaseDontChangeProfileSlug" : "Bitte ändern Sie Profil Slug nicht.",
      "selectFile" : "File Auswählen",
      "changeFile" : "File Ändern",
      "importMembersFailedText" : "Dies kann daran liegen, dass ihnen die E-Mail-Adresse verpasst wird. Bitte Häkchen Sie Ihre Importieren- File und Erneut Versuchen Sie mit einer gültigen E-Mail-Adresse für diese Mitglieder.",
      "upload" : "Upload",
      "tryAgain" : "Erneut versuchen",
      "syncAllPosts" : "Synchronisierung jeder deiner Story und deines Kommentars",
      "membersCouldNotBeAdded" : "Mitglieder konnten der Gruppe nicht hinzugefügt werden.",
      "importMembersSuccess" : "Wir haben jeder Einzelperson Gruppe Mitglieder eine E-Mail gesendet, in der sie ihre Mitgliedschaft in der Gruppe bestätigen und ihnen Details geben. Dies hilft sicherzustellen, dass alle Mitglieder informieren und effektiv mit der Gruppe zugreifen können.",
      "importMembersAdded" : "Mitglieder wurden erfolgreich zur Gruppe hinzugefügt",
      "postsNotSynced" : "Veraltete Posts konnten nicht mit der Gruppe synchronisiert werden. Dies kann daran liegen, dass die Story Ereignisse nicht erfolgreich importiert wurden.",
      "migrationFailed" : "Die Übertragung ist fehlgeschlagen. Bitte Erneut versuchen.",
      "migrationCompleted" : "MiGration Erledigt!",
      "migrationInProgress" : "Übertragung in Gange!",
      "uploadingInProgress" : "Upload in Gange!",
      "listMembers" : "Liste von Mitglieder wird sein",
      "downloaded" : "Herunterladen",
      "uploaded" : "hochgeladen",
      "listPostsDownloaded" : "Liste von Posts ist Herunterladen.",
      "listPostsDownloading" : "Liste von Posts wird herunterladen.",
      "posts" : "Einträge",
      "members" : "Mitglieder",
      "imported" : "importiert",
      "step1" : "Schritt 1",
      "step2" : "Schritt 2",
      "step1Description" : "Erstellen Sie ein Mitglieder Profil in der Vorankündigungsfrist.",
      "step1Description2" : "(einschließlich Name, E-Mail Id und Passwort)",
      "step2Description" : "Geben Sie das Zertifikat für die Mitglieder ein",
      "emailPlaceholder" : "Geben Sie die E-Mail IdIhrer Einrichtung ein",
      "emailTooltip" : "Gib die E-Mail-mitglieder mit deinem sekundärkonto ein",
      "passwordPlaceholder" : "Geben Sie das Passwort Ihrer Einrichtung ein",
      "confirm" : "Bestätigen",
      "validation" : {
        "skoolUrl" : "Bitte geben Sie eine gültige URLein",
        "email" : "E-Mail ist erforderlich",
        "password" : "Das Passwort ist erforderlich"
      }
    }
  },
  "invitations" : {
    "intent" : "Helfen Sie dieser Community zu wachsen!",
    "cancelInvitation" : "Einladung widerrufen",
    "inviteMembers" : "Laden Sie Mitglieder zur Zusammenarbeit in dieser Community ein.",
    "inviteLink" : "Einladungslink",
    "buildYourCommunity" : "Bauen Sie Ihre Community auf!",
    "inviteMembersToCollaborate" : "Sie haben eine neue Community erstellt! Laden Sie Mitglieder zur Zusammenarbeit in dieser Community ein.",
    "invite" : "Einladen"
  },
  "createPost" : {
    "title" : "Neuen Blog-Post erstellen",
    "placeholder" : "Was geht Ihnen durch den Kopf",
    "slug" : "Blog-Post URL-Slug",
    "titleHelp" : "Der Titel, die Beschreibung und das Foto werden für SEO Meta-Tags verwendet",
    "nameLabel" : "Titel des Blog-Posts",
    "nameValidation" : "Titel ist erforderlich",
    "descriptionLabel" : "Beschreibung des Posts",
    "descriptionHelp" : "Geben Sie eine kurze Beschreibung ein, damit die Betrachter einen Einblick in den Post erhalten. Funktioniert am besten zwischen 100 und 250 Zeichen",
    "descriptionValidation" : "Beschreibung ist erforderlich",
    "createLabel" : "Post erstellen",
    "image" : "Foto des Blog-Posts",
    "imageDescription" : "Die empfohlene Größe ist 600px * 400px",
    "notificationTitle" : "Blog-Post erstellt",
    "notificationErrorTitle" : "Blog-Post konnte nicht erstellt werden",
    "postingIn" : "Buchung in",
    "editingIn" : "Bearbeiten in"
  },
  "post" : {
    "deletePost" : "Beitrag löschen",
    "reportPost" : "Beitrag melden",
    "editPost" : "Beitrag bearbeiten",
    "createPost" : "Beitrag erstellen",
    "publish" : "Post",
    "publishPost" : "Beitrag veröffentlichen",
    "addChannel" : "Kanal hinzufügen",
    "selectChannel" : "Bitte wählen Sie einen Channel aus",
    "addLink" : "Link hinzufügen",
    "removeLink" : "Link entfernen",
    "update" : "Aktualisieren",
    "unsavedChanges" : "Sie haben ungespeicherte Änderungen",
    "unsavedChangesMessage" : "Ihre nicht gespeicherten Änderungen gehen verloren. Möchten Sie trotzdem fortfahren?",
    "unpinFromChannel" : "Anheften aufheben",
    "unpinFromHome" : "Anheften aufheben",
    "deletePostConfirmation" : "Möchten Sie diesen Beitrag wirklich löschen?",
    "reportPostConfirmation" : "Möchten Sie diesen Beitrag wirklich melden?",
    "postNotFound" : "Beitrag wurde nicht gefunden",
    "postNotFoundMessage" : "Der Beitrag, den Sie anzeigen möchten, wurde entweder gelöscht oder existiert nicht.",
    "loadMoreComments" : "Weitere Kommentare laden",
    "channelNotFound" : "Kanal nicht gefunden",
    "isCurrentlyLive" : "ist jetzt live",
    "isStartingNow" : "beginnt jetzt",
    "isHappeningInMinutes" : "findet in {minutes} Minuten statt",
    "isHappeningInHours" : "geschieht in {hours} Stunde | geschieht in {hours} Stunde",
    "publicChannel" : "Öffentlicher Kanal",
    "privateChannel" : "Privater Kanal",
    "featured" : "Empfohlen",
    "featuredAbout" : "Über „Empfohlen“",
    "noPostsFound" : "Keine Beiträge gefunden",
    "pinInfo" : "Sie können Elemente anheften, die oben in der Sammlung angezeigt werden sollen, darunter Beiträge, Regeln und Hashtags.",
    "pinInfoEveryone" : "Alle in der Gruppe können diese Elemente sehen.",
    "pinInfoRemainVisible" : "Angeheftete Elemente bleiben sichtbar, bis Sie das Anheften aufheben.",
    "pinInfoNewestItem" : "Wenn Sie Elemente anheften, erscheint das neueste Element ganz oben auf der Liste.",
    "onlyVisibleToAdmins" : "Nur für Admins sichtbar",
    "featuredAboutDescription" : "Ihre Admins haben diese Elemente angeheftet, damit die Gruppe sie sehen kann.",
    "channelNotFoundMessage" : "Sie sind kein Mitglied des Kanals mehr, auf den Sie zugreifen möchten, oder der Kanal wurde gelöscht.",
    "notifications" : {
      "unpinned" : "Anheften aufgehoben!",
      "pinned" : "Angeklickt!",
      "reported" : "Der Beitrag wurde gemeldet!",
      "error" : "Etwas ist schiefgelaufen!"
    },
    "movePostToChannel" : "Zum Kanal Verschieben",
    "pin" : "Anstecken",
    "pinToHome" : "An Startseite anhängen",
    "pinToChannel" : "An Kanal anhängen",
    "whatIsYourTitle" : "Was ist Ihr Titel?",
    "postMovedToChannel" : "Story verschoben auf Kanal {channelName}",
    "onlyAdminsCanPost" : "Only community admins can post in this channel."
  },
  "reaction" : {
    "noLikes" : "Keine Likes",
    "andOthers" : "und {count} andere"
  },
  "UIConfirmation" : {
    "privateGroup" : "Diese Gruppe ist privat",
    "privateGroupMessage" : "Sie müssen Mitglied dieser Gruppe sein, um auf gruppenspezifische Informationen zugreifen zu können. Bitte fordern Sie Zugriff an, indem Sie auf die Schaltfläche „Gruppe beitreten“ klicken."
  },
  "notifications" : {
    "noNotificationsYet" : "Noch keine Benachrichtigungen",
    "whenYouGetNotifications" : "Wenn Sie Benachrichtigungen erhalten, werden diese hier angezeigt",
    "markAllAsRead" : "Alle als gelesen markieren",
    "notifications" : "Benachrichtigungen",
    "all" : "Alle",
    "unread" : "Ungelesen",
    "checkNotifications" : "Melden Sie sich an, um Ihre Benachrichtigungen zu überprüfen",
    "noNotifications" : "Keine Benachrichtigungen!"
  },
  "joinGroupModal" : {
    "wahoo" : "Hurra 🎉Die Anfrage wurde erfolgreich gesendet!",
    "reviewRequestSoon" : "Unsere Gruppenadministratoren werden Ihre Anfrage in Kürze prüfen. Bitte haben Sie ein wenig Geduld. Wir benachrichtigen Sie, sobald Ihr Abonnement genehmigt wurde.",
    "nonMemberMessage" : "Sie müssen Teil dieser Gruppe sein, um Beiträge zu liken und zu kommentieren",
    "subscribeFor" : "Abonnieren für",
    "joinGroup" : "GRUPPE BEITRETEN",
    "membershipPending" : "Mitgliedschaft ausstehend",
    "viewMembershipAnswers" : "Antworten zur Mitgliedschaft Ansicht",
    "requested" : "Angefordert",
    "dayFreeTrial" : "-tägiges kostenloses Trial",
    "notPartOfGroup" : "Sie sind noch nicht Teil dieser Gruppe, Ihre Mitgliedschafts-Anfragen befinden sich in Bewertung. Sobald ein Admin Ihre Anfragen angenommen hat, werden wir Sie benachrichtigen",
    "pleaseAnswerMembershipQuestions" : "Bitte antworten Sie auf die Fragen zur Mitgliedschaft, um dieser Gruppe beitreten zu können"
  },
  "userProfilePopover" : {
    "active" : "Aktiv",
    "longAgo" : "vor langer Zeit",
    "chatDisabled" : "Dieser Benutzer hat seinen Chat deaktiviert",
    "pointsToLevelUp" : "Punkte bis zur nächsthöheren Ebene",
    "profile" : "Profil",
    "deletedUser" : "Gelöschter Benutzer",
    "joined" : "Beigetreten",
    "contributions" : "Beiträge"
  },
  "courses" : {
    "addCourse" : "Kurs hinzufügen",
    "updateCourse" : "Kurs aktualisieren",
    "access" : "Alle Mitglieder haben Zugriff",
    "unableToAddCourse" : "Hoppla! Der Kurs kann nicht hinzugefügt werden",
    "pleaseTryAgainLater" : "Bitte versuchen Sie es später erneut.",
    "paymentIntegrationMissing" : "Hoppla! Die Zahlungsintegration fehlt",
    "paymentIntegrationMissingMessage" : "Bitte integrieren Sie Zahlungen in den Standort, um kostenpflichtige Kurse zu aktivieren",
    "course" : "Kurs",
    "courseInThisGroup" : "einen Kurs in dieser Sammlung",
    "courseLinkCopied" : "Kurs-Link kopiert!",
    "buyNow" : "JETZT KAUFEN",
    "locked" : "LOCKIERT",
    "buyCourse" : "KURSE KAUFEN",
    "open" : "OFFEN",
    "moveCard" : "Karte verschieben",
    "courseViewMessage" : "Sie müssen Teil dieser Gruppe sein, um die Kurse ansehen zu können.",
    "deleteCourse" : "Kurs löschen",
    "deleteCourseConfirmation" : "Möchten Sie diesen Kurs wirklich löschen?",
    "courseAccessNotGranted" : "Kurszugang nicht gewährt",
    "courseAccessNotGrantedMessage" : "Wir arbeiten derzeit daran, Ihnen Zugang zum Kurs zu ermöglichen. Bitte aktualisieren Sie die Seite und versuchen Sie es in einer Minute erneut.",
    "autoRenewsAfter" : "Verlängert sich automatisch nach",
    "oneTimePayment" : "Einmalige Zahlung",
    "emptyCoursesMessage" : "Das sieht ja aus wie eine Geisterstadt … Hier gibt es nichts zu sehen.",
    "updatedSuccessfully" : "Kurs erfolgreich aktualisiert",
    "addedSuccessfully" : "Kurs erfolgreich hinzugefügt",
    "labels" : {
      "selectCourse" : "Kurs auswählen",
      "courseVisibility" : "Sichtbarkeit",
      "courseAccess" : "Kurszugang",
      "coursePrice" : "Kurspreis",
      "subscriptionType" : "Abonnementstyp",
      "billingPeriod" : "Abrechnungszeitraum",
      "testMode" : "Test-Modus",
      "turnOnTestPayments" : "Testzahlungen mit einer Testkarte aktivieren",
      "currency" : "Währung",
      "trialDays" : "Trial-Tage",
      "recurring" : "Wiederkehrend",
      "free" : "Frei",
      "oneTime" : "Ein Datum",
      "refresh" : "Aktualisieren",
      "accessStartsAtDay" : "Der Zugriff beginnt bei Tag",
      "maximumYouCanEnterIs365" : "Max.. Sie können 365 eingeben",
      "allMembers" : "jeder Mitglieder",
      "levelUnlock" : "Gleich Interactive",
      "buyNow" : "Jetzt kaufen",
      "timeUnlock" : "Datum freischalten",
      "gamificationLevel" : "Gamifizierung Gleich",
      "privateChannel" : "Privat Kanal",
      "marketingChannel" : "Marketing"
    },
    "placeholders" : {
      "enterPrice" : "Preis eingeben",
      "enterTrialDays" : "Trial-Tage eingeben",
      "selectCurrency" : "Eine Option auswählen",
      "selectBillingPeriod" : "Eine Option auswählen"
    },
    "validations" : {
      "validPrice" : "Bitte geben Sie einen gültigen Preis ein",
      "required" : "Bitte wählen Sie einen Kurs aus",
      "validMembershipPrice" : "Bitte geben Sie einen gültigen Mitgliedschaftspreis ein",
      "validTrialDays" : "Bitte geben Sie gültige Trial-Tage ein",
      "requiredSubscriptionType" : "Bitte wählen Sie den Abonnementtyp",
      "courseVisibility" : "Bitte Auswählen Kurs Sichtbarkeit",
      "requiredGamificationLevel" : "Bitte Auswählen Gamifizierung Gleich",
      "requiredPrivateChannel" : "Bitte Auswählen Privaten Kanal",
      "validAccessStartDay" : "Bitte geben Sie ein gültiges Zugriff-start- Tag ein"
    },
    "descriptions" : {
      "buyNowDescription" : "Dieser Kurs ist beim Kauf öffentlich",
      "timeUnlockDescription" : "Mitglieder entferne spätere",
      "levelUnlockDescription" : "Mitglieder können nur mit einem bestimmten Gleich aufschließen",
      "allMembersDescription" : "Jeder Mitglieder hat Zugriff auf diesen Kurs",
      "privateChannelDescription" : "Mitglieder eines Privatkanals"
    },
    "helperText" : {
      "levelBased" : "Stufenweise",
      "timeLimited" : "Stundenlimitiert",
      "free" : "Frei",
      "levelAvailableAt" : "Verfügbar bei Gleich 0{value}",
      "timeLimitedAfterJoining" : "Öffentlich {value} {day} Später beitreten der Gruppe",
      "day" : "Tag",
      "days" : "Tage",
      "purchaseToUnlockAccess" : "Kaufen diesen Kurs, um Zugriff freizustellen",
      "locked" : "Dieser Kurs ist gesperrt",
      "unlockAtLevel" : "Dieser Kurs wird bei Gleich {level}",
      "unlockAfterDays" : "Dieser Kurs wird später {days} {dayText}freischalten",
      "privateChannelBased" : "Auf Privat Kanal basieren"
    }
  },
  "leaderboard" : {
    "level" : "Ebene",
    "lastUpdated" : "Zuletzt aktualisiert",
    "members" : "Mitglieder",
    "percentOfMembers" : "{percentage} % der Mitglieder",
    "rewards" : "Belohnungen",
    "allTime" : "Alle Zeiten",
    "pointsToLevelUp" : "Punkte bis zur nächsthöheren Ebene",
    "points" : "Punkte",
    "leaderboard7d" : "Bestenliste (7 Tage)",
    "leaderboard30d" : "Bestenliste (30 Tage)",
    "leaderboardAlltime" : "Bestenliste (gesamte Zeit)",
    "yourRank" : "Ihr Rang",
    "noActivityToShow" : "Keine Aktivität anzuzeigen",
    "rewardsWillBeDisplayedHere" : "Belohnungen werden hier angezeigt",
    "seeAllLeaderboards" : "Alle Bestenlisten ansehen",
    "addRewards" : "Belohnungen hinzufügen",
    "howPointsWork" : "Sie sammeln Punkte, wenn andere Mitglieder Ihre Beiträge oder Ihr Feedback liken. 1 Like = 1 Punkt. Dies ermutigt Benutzer, qualitativ hochwertige Inhalte zu erstellen und mit anderen Mitgliedern ihrer Community zu interagieren.",
    "levels" : "Ebenen",
    "levelsDescription" : "Wenn Sie Punkte sammeln, steigen Sie auf die nächste Ebene auf. Ihre Ebene wird unten rechts in Ihrem Avatar angezeigt. Die zum Erreichen der nächsten Ebene erforderliche Punktzahl wird in der Fortschrittsleiste auf dem Bestenlisten-Bildschirm angezeigt.",
    "pointsAndLevels" : "Punkte & Schichten"
  },
  "events" : {
    "createEvent" : "Veranstaltung erstellen",
    "dragAndDrop" : "SVG, PNG oder JPG (max. 800 x 400 Pixel) per Drag & Drop platzieren",
    "editEvent" : "Veranstaltung bearbeiten",
    "addEvent" : "Veranstaltung hinzufügen",
    "paymentDetails" : "Zahlungsdetails",
    "event" : "Veranstaltung",
    "goBack" : "Zurück",
    "cancelEdit" : "Bearbeiten abbrechen",
    "cancelEvent" : "Veranstaltung absagen",
    "next" : "Nächste",
    "saveEvent" : "Veranstaltung speichern",
    "editRecurringEvent" : "Wiederkehrendes Event bearbeiten",
    "thisEvent" : "Diese Veranstaltung",
    "thisAndFollowingEvents" : "Diese und folgende Veranstaltungen",
    "ok" : "OK",
    "deleteRecurringEvent" : "Wiederkehrendes Event löschen",
    "allEvents" : "Alle Veranstaltungen",
    "deleteEvent" : "Veranstaltung löschen",
    "onceEventDeleted" : "Wenn die Veranstaltung gelöscht ist, wird sie nicht mehr in Ihrem Kalender angezeigt.",
    "toRegister" : "zum Registrieren",
    "calendar" : "Kalender",
    "addToCalendar" : "Zum Kalender hinzufügen",
    "declineRegistration" : "Ablehnen",
    "paymentFailedMessage" : "Ihre Zahlung ist aufgrund unvorhergesehener Umstände fehlgeschlagen! Bitte versuchen Sie es später erneut.",
    "upcoming" : "Demnächst",
    "noMoreEvents" : "Keine weiteren Veranstaltungen zum Anzeigen",
    "joinGroupToRegister" : "Sie müssen Teil dieser Gruppe sein, um sich für diese Veranstaltung anzumelden",
    "past" : "Vergangene",
    "youHaveRegisteredForOneEvent" : "Sie haben sich für 1 Veranstaltung angemeldet. Wir senden Ihnen einen Tag vor jeder Veranstaltung eine Erinnerung.",
    "upcomingEvents" : "Bevorstehende Veranstaltungen",
    "noUpcomingEvents" : "Keine bevorstehenden Veranstaltungen",
    "pastEvents" : "Vergangene Veranstaltungen",
    "noPastEvents" : "Keine vergangenen Veranstaltungen",
    "noMatchingEventFound" : "Keine passende Veranstaltung gefunden",
    "week" : "Woche",
    "month" : "Monat",
    "today" : "Heute",
    "registrationConfirmed" : "Registrierung Bestätigt für {event}.",
    "validations" : {
      "titleValidation" : "Titel ist erforderlich",
      "colorValidation" : "Farbe ist erforderlich",
      "startTimeValidation" : "Startzeit ist erforderlich",
      "endTimeValidation" : "Endzeit ist erforderlich",
      "endTimeAfterStartTime" : "Die Endzeit muss nach der Startzeit liegen",
      "startTimeMustBeInFuture" : "Startzeit muss in der Zukunft liegen",
      "locationValidation" : "Standort ist erforderlich",
      "locationValidationMobile" : "Standort ist erforderlich",
      "locationUrlValidation" : "Eine gültige Standort-URL ist erforderlich",
      "descriptionValidation" : "Beschreibung ist erforderlich",
      "descriptionValidationMaxLength" : "Die Beschreibung darf 300 Zeichen nicht überschreiten",
      "recaptchaError" : "Überprüfung fehlgeschlagen! Bitte versuchen Sie es erneut",
      "repeatIntervalValidation" : "Frequenz ist erforderlich",
      "repeatIntervalValidator" : "Das Repeat Interval sollte entweder Tag, Woche, Monat oder Jahr sein.",
      "repeatIntervalRequired" : "Das Wiederholen Sekunden ist Erforderlich",
      "repeatOccurrenceValidator" : "Die Wiederholungsfrequenz muss größer als 0 sein",
      "repeatOccurrenceRequired" : "Wiederholte Frequenz ist erforderlich",
      "invalidDateFormat" : "Ungültiges Datumsformat",
      "endDateMustBeAfterStartDate" : "Das Enddatum muss nach dem Startdatum der Veranstaltung liegen",
      "recurringEndDateValidation" : "Ein Enddatum für das wiederkehrende Ereignis ist erforderlich",
      "repeatsOnValidation" : "Bitte wählen Sie mindestens einen Tag aus",
      "invalidDaySelection" : "Ungültige Tagesauswahl",
      "endOptionRequired" : "Endoption ist erforderlich",
      "levelValidation" : "Bitte wählen Sie eine Ebene aus",
      "courseValidation" : "Bitte wählen Sie einen Kurs aus",
      "channelValidation" : "Bitte wählen Sie einen Channel aus",
      "eventPriceValidation" : "Preis ist erforderlich und muss größer als {min}sein"
    },
    "placeholders" : {
      "selectStartTime" : "Startzeit auswählen",
      "selectEndTime" : "Endzeit auswählen",
      "selectLocation" : "Standort auswählen",
      "locationUrl" : "Link/Adresse",
      "description" : "Beschreibung",
      "selectRecurringEndDate" : "Wiederkehrendes Enddatum auswählen",
      "selectDate" : "Datum auswählen",
      "event" : "Veranstaltung",
      "selectColor" : "Wählen Sie eine Farbe aus",
      "selectAttendees" : "Teilnehmer auswählen",
      "selectPrivateChannel" : "Privaten Channel auswählen",
      "selectCourse" : "Kurs auswählen",
      "selectLevels" : "Ebenen auswählen",
      "selectCalendar" : "Kalender auswählen"
    },
    "labels" : {
      "startTime" : "Startzeit",
      "endTime" : "Endzeit",
      "others" : "Andere",
      "oneTimePriceForEventRegistration" : "einmaliger Preis für die Veranstaltungsregistrierung.",
      "totalAmount" : "Gesamtbetrag",
      "cardAuthorizationText" : "Durch die Angabe Ihrer Karteninformationen erlauben Sie {locationName}, Ihre Karte für zukünftige Zahlungen gemäß deren Bedingungen zu belasten.",
      "secureAndSafePayments" : "100 % sichere Zahlungen",
      "day" : "Tag",
      "week" : "Woche",
      "month" : "Monat",
      "year" : "Jahr",
      "recurringEvent" : "Wird die Veranstaltung ein wiederkehrendes Event sein?",
      "repeatsEvery" : "Wiederholt sich jede/jeden/jedes",
      "repeatsOn" : "Wiederholt sich am",
      "end" : "Ende",
      "ends" : "Ende",
      "neverEnds" : "Endet nie",
      "orange" : "Orange",
      "red" : "Rot",
      "blue" : "Blau",
      "green" : "Grün",
      "violet" : "Violett",
      "purple" : "Lila",
      "yellow" : "Gelb",
      "title" : "Titel",
      "color" : "Farbe",
      "allMembers" : "Alle Mitglieder",
      "membersAtALevel" : "Mitglieder auf einem Level",
      "membersOfACourse" : "Mitglieder eines Kurses",
      "membersOfAPrivateChannel" : "Mitglieder eines privaten Kanals",
      "whoCanAttendTheEvent" : "Wer kann an der Veranstaltung teilnehmen?",
      "channel" : "Channel",
      "course" : "Kurs",
      "level" : "Ebene",
      "remindAttendeesByEmail" : "Erinnere Teilnehmer Via E-Mail an 1 Tag Vorher",
      "hideLocationFromNonAttendees" : "Standort für Nicht-Teilnehmer verbergen.",
      "addChargesToTheEvent" : "Abrechnung zur Veranstaltung hinzufügen",
      "noPaymentRequired" : "Keine Zahlung erforderlich",
      "location" : "Standort",
      "link" : "Link",
      "description" : "Beschreibung",
      "timezone" : "Zeitzone",
      "eventType" : "Veranstaltungstyp",
      "eventTypeChangeWarning" : "Dynamisch zum Veranstaltungstyp Oder die Preisgestaltung wird auf jede Vorkommnisse in der Reihe angewendet.",
      "never" : "Niemals",
      "on" : "An",
      "after" : "Später",
      "occurrences" : "Vorkommnisse",
      "selectEventEnd" : "Auswählen, wenn die Veranstaltung enden wird.",
      "turnOnTestPayments" : "Umdrehen An Test über eine Test Karte",
      "pay" : "Bezahlen",
      "hideAttendees" : "Ausblenden Teilnehmer Von Gruppe Mitglieder",
      "guests" : "{count} Gäste",
      "guestList" : "Gast Liste",
      "noAttendees" : "Noch keine Teilnehmer",
      "viewAttendees" : "Teilnehmer Ansicht",
      "exportAttendees" : "Teilnehmer Exportieren"
    },
    "notifications" : {
      "eventCreated" : "Veranstaltung erfolgreich erstellt!",
      "eventUpdated" : "Veranstaltung erfolgreich aktualisiert!",
      "eventCreationFailed" : "Die Veranstaltungserstellung ist fehlgeschlagen!",
      "eventUpdateFailed" : "Das Aktualisieren der Veranstaltung ist fehlgeschlagen!",
      "eventDeleted" : "Veranstaltung erfolgreich gelöscht!",
      "eventDeletionFailed" : "Das Löschen der Veranstaltung ist fehlgeschlagen!",
      "paymentFailed" : "Zahlung fehlgeschlagen!",
      "registrationSuccessful" : "Registrierung erfolgreich!",
      "registrationFailed" : "Registrierung fehlgeschlagen!",
      "addToCalendarFailed" : "Die Veranstaltung konnte nicht zum Kalender hinzugefügt werden!",
      "locationDetailsCopied" : "Die Standortdetails wurden in die Zwischenablage kopiert!",
      "registrationDeclined" : "Registrierung erfolgreich abgelehnt!",
      "registrationDeclinedFailed" : "Ablehnung der Registrierung fehlgeschlagen!",
      "fetchAttendeesFailed" : "Teilnehmer Fehlgeschlagen geladen werden",
      "emailCopied" : "E-Mail kopiert in die Zwischenablage"
    }
  },
  "login" : {
    "invite" : "hat Sie eingeladen, beizutreten"
  },
  "contentReports" : {
    "contentDeleted" : "Der Inhalt wurde gelöscht!",
    "noActionTaken" : "Es werden keine Handlungen bezüglich des gemeldeten Inhalts ergriffen!",
    "reportedContentNotFound" : "Der gemeldete Inhalt wurde nicht gefunden –möglicherweise wurde bereits auf die Meldung reagiert.",
    "reported" : "Gemeldet",
    "viewAllReportedContentHere" : "Hier können Sie alle gemeldeten Inhalte einsehen",
    "takeActionOnReportedContent" : "Maßnahmen in Bezug auf den gemeldeten Inhalt ergreifen",
    "andOthers" : "und {count} andere",
    "reportedThisPost" : "hat diesen Beitrag gemeldet",
    "keep" : "BEHALTEN",
    "remove" : "ENTFERNEN",
    "deleteContent" : "Inhalt löschen",
    "deleteConfirmation" : "Möchten Sie diesen Inhalt wirklich löschen?",
    "noMemberReportedContent" : "Kein von Mitgliedern gemeldeter Inhalt",
    "whenMembersReportPostsOrComments" : "Wenn Mitglieder Beiträge oder Feedback melden, werden diese hier angezeigt, damit Sie sie überprüfen können. Sie können sie behalten oder löschen sowie die Mitglieder, die sie gepostet haben, suspendieren, entfernen oder blockieren."
  },
  "contentUnavailable" : {
    "thisContentIsntAvailable" : "Dieser Inhalt ist im Moment nicht verfügbar",
    "whenThisHappens" : "Wenn dies der Fall ist, liegt es in der Regel daran, dass der Besitzer ihn nur mit einer kleinen Gruppe von Personen geteilt hat oder geändert hat, wer ihn sehen kann, oder er wurde gelöscht"
  },
  "noCommunities" : {
    "noCommunitiesFound" : "Keine Communitys gefunden",
    "startCreatingYourOwnCommunities" : "Beginnen Sie mit der Erstellung Ihrer eigenen Communitys und interagieren Sie mit Ihrer Zielgruppe!"
  },
  "notFound" : {
    "ohNo" : "Oh nein …",
    "weHaveHadAnError" : "Es ist ein Fehler aufgetreten",
    "error404" : "Fehler 404",
    "sorryPleaseCheckBack" : "Entschuldigung … Bitte schauen Sie in später noch einmal vorbei."
  },
  "time" : {
    "justNow" : "Erst jetzt",
    "timeAgo" : "{value}{unit} vor",
    "timeAgoFull" : "{value} {unit} vor",
    "units" : {
      "year" : "y",
      "years" : "Jahre",
      "month" : "Mo",
      "months" : "Monate",
      "week" : "m",
      "weeks" : "Wochen",
      "day" : "D",
      "days" : "Tage",
      "hour" : "h",
      "hours" : "Stunde",
      "minute" : "m",
      "minutes" : "Minuten",
      "second" : "s",
      "seconds" : "Sekunden",
      "monthly" : "Monatlich",
      "weekly" : "Wöchentlich",
      "annually" : "Jährlich"
    }
  },
  "emojiPicker" : {
    "notfound" : "Kein E-Mail gefunden",
    "recent" : "Vielfältige Möglichkeiten",
    "smileys" : "SMS und E-Mail",
    "people" : "Personen und Textkörper",
    "nature" : "Tiere und Natur",
    "foods" : "E-Mail und Trinkgeld",
    "activity" : "Aktivität",
    "places" : "Weg & Plätze",
    "objects" : "Objekte",
    "symbols" : "Symbole",
    "flags" : "Flags",
    "custom" : "Benutzerdefiniert"
  },
  "topNavBarHeaderText" : {
    "discussion" : "Diskussion",
    "learning" : "Lernen",
    "people" : "Volk"
  }
}
